export const sceneFont = '/assets/fonts/ark-pixel-12px-proportional-zh-cn.woff';
